import { CircuitoTomoData } from "./CircuitoTomoData";
import React, { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setCircuitoTomo } from "../../../context/Actions/turnos/estudioTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import HeaderModal from "../headerModal/headerModal";
import "./Circuito.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";

const CircuitoTomo = ({
  titulo,
  dissmiss,
  danger,
  texto,
  completarFormulario,
}) => {
  const { estudioTurnosDispatch, estudioTurnosState } =
    useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch, toasterState } = useContext(GlobalContext);

  const [circuitoFiltrado, setCircuitoFiltrado] = useState(CircuitoTomoData);
  const [refer, setRefer] = useState(false);

  const onChangeRadio = (e) => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoTomo);
    let arrX = circuitoFiltrado;
    if (e.target.name === "pesoSuperior" && e.target.value === "true") {
      setCircuitoTomo({
        ...x,
        [e.target.name]: true,
      })(estudioTurnosDispatch);

      arrX = arrX.map((item) =>
        item.name === "pesoSuperiorCritico"
          ? { ...item, [`visible`]: true }
          : item
      );
    } else if (e.target.name === "pesoSuperior" && e.target.value === "false") {
      setCircuitoTomo({
        ...x,
        pesoSuperiorCritico: false,
        pesoSuperior: false,
      })(estudioTurnosDispatch);
      arrX = arrX.map((item) =>
        item.name === "pesoSuperiorCritico"
          ? { ...item, [`visible`]: false, [`valor`]: null }
          : item
      );
    } else if (e.target.name === "conContraste" && e.target.value === "true") {
      setRefer(true);
      setCircuitoTomo({
        ...x,
        [e.target.name]: true,
      })(estudioTurnosDispatch);
      arrX = arrX.map((item) =>
        item.name === "insRenal" ||
        item.name === "diabeticoHipertenso" ||
        item.name === "contrasteReciente" ||
        item.name === "embarazada" ||
        item.name === "amamantando"
          ? { ...item, [`visible`]: true }
          : item
      );
    } else if (e.target.name === "conContraste" && e.target.value === "false") {
      setRefer(false);
      setCircuitoTomo({
        ...x,
        conContraste: false,
        insRenal: false,
        diabeticoHipertenso: false,
        contrasteReciente: false,
        embarazada: false,
        amamantando: false,
      })(estudioTurnosDispatch);
      arrX = arrX.map((item) =>
        item.name === "insRenal" ||
        item.name === "diabeticoHipertenso" ||
        item.name === "contrasteReciente" ||
        item.name === "embarazada" ||
        item.name === "amamantando"
          ? { ...item, [`visible`]: false, [`valor`]: null }
          : item
      );
    } else {
      setCircuitoTomo({
        ...x,
        [e.target.name]: e.target.value === "true" ? true : false,
      })(estudioTurnosDispatch);
    }
    arrX = arrX.map((item) =>
      item.name === e.target.name
        ? { ...item, [`valor`]: e.target.value === "true" ? true : false }
        : item
    );
    setCircuitoFiltrado(arrX);
  };

  const onClickVolverCirc = () => {
    setCircuitoFiltrado(CircuitoTomoData);
    dissmiss();
  };

  const onClickBusqCirc = () => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoTomo);
    let arrX = circuitoFiltrado;
    arrX = arrX.filter((item) => (item.visible === true ? item : ""));
    arrX = arrX.filter((item) => item.valor === null);
    if (arrX.length > 0) {
      showToaster(
        {
          texto: "Complete las preguntas!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      setCircuitoFiltrado(CircuitoTomoData);
      // completarFormulario("TOMO", x);
      setCircuitoTomo({
        ...x,
        flgForm: true,
      })(estudioTurnosDispatch);
    }
  };

  let modalAutoScroll = document.documentElement.getElementsByClassName(
    "ptur-circuito-boxTomo"
  );

  useEffect(() => {
    if (refer) {
      modalAutoScroll[0].scrollTo({ top: 200, behavior: "smooth" });
    }
    if (toasterState.toaster.show) {
      window.scrollTo({ top: 380, behavior: "smooth" });
      setRefer(false);
    }
  }, [refer]);

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />
      <div className="ptur-circuitoTomo-bodyModal">
        <div className="ptur-circuito-tituloDesc">
          <p className="rb18l titulo-circuito">{texto}</p>
        </div>
        <div className="ptur-circuito-boxTomo">
          {circuitoFiltrado.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {item.visible && (
                  <div className="ptur-circuito-boxPreguntas">
                    <div className="ptur-circuito-preguntaDesc">
                      <span className="rb14l">{item.pregunta}</span>
                    </div>
                    <div className="ptur-circuito-radios">
                      <span>
                        <InputV1
                          name={item.name}
                          nombreRadio={item.name}
                          onChange={onChangeRadio}
                          value={true}
                          inputType="radio"
                          labelStr={"Sí"}
                          radioClass="ptur-circuito-radio"
                        />
                      </span>
                      <span>
                        <InputV1
                          name={item.name}
                          nombreRadio={item.name}
                          onChange={onChangeRadio}
                          value={false}
                          inputType="radio"
                          labelStr={"No"}
                          radioClass="ptur-circuito-radio"
                        />
                      </span>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className="ptur-circuito-boxBtn">
          <button
            className="ptur-circuito-btnVolver c-latex30 rb16m"
            onClick={onClickVolverCirc}
          >
            Volver
          </button>
          <button
            className="ptur-circuito-btnBusq c-white rb16m"
            onClick={onClickBusqCirc}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </>
  );
};

export default CircuitoTomo;
